// @flow

import { observer } from "mobx-react";
import * as React from "react";
import ReactPasswordStrength from "react-password-strength";

import "./PasswordStrength.scss";

type Props = {
    onChange: Function
};

@observer
export default class PasswordStrength extends React.Component<Props> {
    handleChange = ({ password }: any) => {
        this.props.onChange(password);
    };

    render() {
        const inputProps = {
            placeholder: "Your password",
            id: "password",
            name: "password",
            minLength: 8,
            required: "required",
            title: "Must contain 8 or more characters",
            autoFocus: false,
            className: "form-control"
        };

        return (
            <ReactPasswordStrength
                minLength={8}
                inputProps={inputProps}
                changeCallback={this.handleChange}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/PasswordStrength/PasswordStrength.js